import { LS_PREFIX } from 'config'

export const LS_KEY_SKIP_DISCLAIMER = `${LS_PREFIX}-skip-dislaimer`
